import type { CopyShape } from "@tami/core/intl";

import type { DASHBOARD_SCRIPT_COPY_PT_BR } from "../dashboard-script.copy";

export const DASHBOARD_SCRIPT_COPY_ES_ES: CopyShape<typeof DASHBOARD_SCRIPT_COPY_PT_BR> = {
  dashIntro: {
    narrative: "Tu panel reúne rendimiento, rutina y entregas — todo lo que importa para tu carrera como creator.",
  },
  dashGreeting: {
    narrative:
      "Empieza el día sabiendo exactamente qué tienes que publicar, entregar y resolver — sin abrir cinco apps distintas.",
    callout: "¡Buenos días, Ana! Aquí tienes el resumen de tu día de un vistazo.",
  },
  dashOverview1: {
    narrative: "Menos hojas de cálculo, menos caos — más tiempo para crear.",
  },
  dashSocial: {
    narrative: "Sigue la tasa de engagement y la evolución de seguidores en cada red, siempre al día.",
    callout: "Instagram, TikTok y YouTube conectados — seguidores y engagement lado a lado.",
  },
  dashOverview2: {
    narrative: "Gráficos fáciles de leer, con el rendimiento de tus semanas.",
  },
  dashKpis: {
    narrative: "Ingresos, campañas activas, entregas pendientes y engagement general — monitorizados automáticamente para ti.",
    callout: "KPIs del mes en tiempo real: ingresos, campañas, entregas y engagement.",
  },
  dashOverview3: {
    narrative: "Entiende tu rendimiento semana a semana, sin suposiciones.",
  },
  dashPosts: {
    narrative: "Ten una lista clara de lo que hay que publicar hoy y esta semana — con hora, plataforma y formato.",
    callout: "Publis y orgánico por separado: sabes qué sale hoy y qué viene esta semana.",
  },
  dashAgenda: {
    narrative: "Reuniones, grabaciones y citas del día integradas en tu rutina — nada queda disperso.",
    callout: "Agenda del día sincronizada: llamadas, grabaciones y entregas en un solo sitio.",
  },
};
